import { Component, OnInit } from '@angular/core';
import { MenuConfigService, MenuAsideService } from '../../../core/_base/layout';
import { MenuConfig } from '../../../core/_config/menu.config';

@Component({
  selector: 'kt-my-page',
  templateUrl: './my-page.component.html',
  styleUrls: ['./my-page.component.scss']
})
export class MyPageComponent implements OnInit {

  constructor(private menuConfigService: MenuConfigService,
    public menuAsideService: MenuAsideService) { }

  ngOnInit() {

  //   console.log("Load menu novo")
  //  this.menuConfigService.loadConfigs(new MenuConfig2().configs);
  //  this.menuAsideService.loadMenu();
  }


  teste()
  {
    var newTab = window.open("http://www.spolti.com.br");


  }
}
